import { render } from "./BillerView.vue?vue&type=template&id=ff9fdfc4"
import script from "./BillerView.vue?vue&type=script&lang=js"
export * from "./BillerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__